export enum EntityWithUpload {
  User,
  Club,
  Course,
  Event,
  Hole,
  Resource,
  Review
}
